.app-root {
  position: relative;
  display: grid;
  grid-template:
    'sidebar chat header' auto
    'sidebar chat content' 1fr
    'footer footer footer' auto / min-content auto 1fr;
  overflow: hidden;
}

.backdrop {
  --background-gradient-dark: var(
    --theme-background-image,
    radial-gradient(at 20% -20%, var(--mantine-color-dark-accent-9), transparent 40%),
    radial-gradient(at 80% 0%, var(--mantine-color-dark-accent-9), transparent 40%),
    radial-gradient(
      at 50% -20%,
      color-mix(in oklch, var(--mantine-color-dark-accent-9), var(--mantine-color-grape-9) 30%),
      transparent 30%
    ),
    radial-gradient(at 80% -20%, var(--mantine-color-dark-8), transparent)
  );
  position: fixed;
  inset: 0;
  pointer-events: none;
  background: light-dark(
    var(--theme-background-light, var(--mantine-color-body)),
    var(--theme-background-dark, var(--mantine-color-dark-9))
  );
  background-image: light-dark(none, var(--background-gradient-dark));
}

.background-video {
  position: absolute;
  inset: 0;
  display: var(--theme-background-video-display, block);
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  mix-blend-mode: light-dark(multiply, color-dodge);
  filter: light-dark(
    grayscale() brightness(var(--theme-background-video-brightness, 0.5)) blur(var(--theme-background-video-blur, 0rem))
      invert(1) opacity(0.2),
    grayscale() brightness(var(--theme-background-video-brightness, 0.5)) blur(var(--theme-background-video-blur, 0rem))
  );
}
